import { Grid } from '@mui/material';
import ItineraryText from '@FlightsComponents/ItineraryText';

const FlightTextItem = ({ xs, children, weight = 600, sxItem = {} }) => {
  return (
    <Grid item xs={xs}>
      <ItineraryText
        sx={{
          fontWeight: weight,
          textAlign: 'center',
          lineHeight: 1.2,
          ...sxItem,
        }}
      >
        {children}
      </ItineraryText>
    </Grid>
  );
};

export default FlightTextItem;
